<template>
  <router-link class="link" :to="`/console/view?metric_id=${metric.id}`">
    <div class="summary-metric-card smooth-shadow">
      <h3 class="ellipsis">{{ getMetricName(metric.name) }}</h3>
      <label>last 24 hours</label>
      <p>{{ `${metric.getSingleValue() || "0"}` }}</p>
      <div id="chart">
        <apexchart
          type="area"
          height="130"
          width="100%"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>
  </router-link>
</template>

<script>
import moment from "@/lib/moment";
import { format } from "@/lib/numberFormatter";

export default {
  props: {
    metric: Object,
  },
  data() {
    return {
      theme: "light",
      dataSet: [],
      chartOptions: {
        chart: {
          height: 100,
          stacked: false,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          line: {
            curve: "smooth",
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          enabled: false,
        },
        stroke: {
          show: true,
          colors: ["var(--color-accent)"],
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        xaxis: {
          type: "datetime",
          tickAmount: 8,
          labels: {
            show: false,
            rotate: -15,
            rotateAlways: true,
          },
          axisBorder: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        title: {
          show: false,
        },
        tooltip: {
          shared: false,
          x: {
            show: true,
            format: "dd MMM",
            formatter: value => {
              return moment(new Date(value * 1000)).format("DD/MM/YY h:mm a");
            },
          },
        },
        legend: {
          show: false,
        },
        grid: {
          show: false,
        },
      },
    };
  },
  computed: {
    series: function() {
      return [
        {
          name: this.metric.name,
          data: this.metric.timeData,
        },
      ];
    },
  },
  methods: {
    getMetricName(name) {
      // let newName = name.slice(0, name.length - 1);
      // return newName.split("(")[1];
      return name;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.apexcharts-tooltip {
  background: var(--color-secondary-light) !important;
  color: var(--font-color) !important;
  border: 1px solid var(--border-color) !important;

  & .apexcharts-tooltip-title {
    color: var(--font-color) !important;
    background: var(--color-secondary-light) !important;
    border-bottom: 1px solid var(--border-color) !important;
  }
}

.link {
  min-width: 0;
}

.summary-metric-card {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  color: var(--font-color);
  border-radius: 5px;
  padding: 0px;
  transition: 0.2s all ease-in-out;
  min-width: 0;

  &:hover {
    cursor: pointer;
    box-shadow: 0 10px 15px #453d4d33;
    transform: scale(1.01);
  }

  &:active {
    transform: scale(0.98);
  }

  h3 {
    padding: 15px 15px 5px 15px;
    text-transform: capitalize;
  }

  label {
    padding: 0 15px;
    font-size: 0.9em;
    opacity: 0.7;
    color: var(--color-primary);
  }

  p {
    margin: 0;
    line-height: 30px;
    font-size: 2.5em;
    padding: 10px 15px 10px 15px;
  }
}
</style>
